import styled from 'styled-components'

/** Curated cover art, all CADINU's own (the old profile's level banners + the six Identity Arts characters). Never a user upload. */
export const COVERS: { id: string; label: string; src: string; kind: 'banner' | 'character' }[] = [
  { id: 'level1', label: 'Level 1', src: '/images/teams/level1-banner.JPEG', kind: 'banner' },
  { id: 'level2', label: 'Level 2', src: '/images/teams/level2-banner.JPEG', kind: 'banner' },
  { id: 'global', label: 'CADINU', src: '/images/teams/global-banner.jpg', kind: 'banner' },
  ...['artist', 'business', 'cowboy', 'loyalty', 'futuristic', 'hunter'].map((c) => ({
    id: c,
    label: c[0].toUpperCase() + c.slice(1),
    src: `/images/brand/nft/${c}.webp`,
    kind: 'character' as const,
  })),
]

/** The old profile's rule when nothing was chosen: the banner of the avatar's level, else the CADINU banner. */
export function coverFor(id: string | null | undefined, level?: number | null) {
  return COVERS.find((c) => c.id === id) ?? COVERS.find((c) => c.id === (level === 2 ? 'level2' : level === 1 ? 'level1' : 'global'))!
}

const Frame = styled.div<{ $h: number }>`
  position: relative;
  height: ${({ $h }) => Math.round($h * 0.7)}px;
  border-radius: 20px;
  overflow: hidden;
  background: radial-gradient(120% 120% at 100% 0%, rgba(154, 123, 255, 0.55), transparent 55%),
    radial-gradient(120% 120% at 0% 100%, rgba(127, 212, 232, 0.45), transparent 55%), #0d1530;
  ${({ theme }) => theme.mediaQueries.md} {
    height: ${({ $h }) => $h}px;
  }
  img {
    position: absolute;
    display: block;
  }
  img.banner {
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  img.character {
    right: 4%;
    bottom: -14%;
    height: 122%;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 0 0 4px rgba(127, 212, 232, 0.35), 0 0 60px rgba(127, 212, 232, 0.35);
  }
`
export function Cover({ id, level, h = 200 }: { id?: string | null; level?: number | null; h?: number }) {
  const c = coverFor(id, level)
  return (
    <Frame $h={h} data-testid="profile-cover" data-cover={c.id}>
      <img className={c.kind} src={c.src} alt="" />
    </Frame>
  )
}
